/* eslint-disable babel/camelcase -- used snake_case because the schemas for business events works with such notation */
import { Features, Test } from "@kiwicom/darwin"
import { load as getSession } from "@kiwicom/nitro/lib/services/session/session"
import * as sessionConsts from "@kiwicom/nitro/lib/consts/session"
import { Cookie, load as getCookie } from "@kiwicom/cookies"

import session from "@kiwicom/frontend-common/browser/session"
import { LangInfo } from "@kiwicom/nitro/lib/records/LangInfo"
import { Brand } from "@kiwicom/nitro/lib/records/Brand"
import { isLoggedIn } from "@kiwicom/nitro/lib/services/auth"
import { CommonWithoutIdTimestamp } from "@kiwicom/event"

export const topic =
  typeof window !== "undefined" &&
  window.SP_GLOBALS.SKYPICKER_ENV === "production" &&
  !window.SP_GLOBALS.IS_STAGING
    ? "projects/mmb-clients-prod-6edd35e1/topics/post-booking"
    : "projects/mmb-clients-sbox-18332c1d/topics/post-booking"

// eslint-disable-next-line init-declarations
declare const window: {
  SP_GLOBALS: {
    BRANDID: string
    RELEASE_INFO: {
      commit_hash: string
    }
    DISPLAY_PLATFORM:
      | "native-ios"
      | "native-android"
      | "only-web"
      | "webview-android"
      | "webview-ios"
    IP: string
    SKYPICKER_LANGUAGE: LangInfo
    SKYPICKER_LOCALE: string
    SKYPICKER_ENV: string
    IS_STAGING: boolean
  }
  __BRAND__: Brand
  __DARWIN__: {
    tests: Test[]
    features?: Features
    winners?: Test[]
  }
} & Window

export const getCommon = async (): Promise<CommonWithoutIdTimestamp> => {
  return {
    ab_tests: window.__DARWIN__.tests,
    account_id: getSession(sessionConsts.ACCOUNT_ID) ?? undefined,
    affil_id: getCookie(Cookie.AFFILIATE_ID) ?? undefined,
    branding_id: window.__BRAND__.id,
    build_version: window.SP_GLOBALS.RELEASE_INFO.commit_hash,
    display_platform: window.SP_GLOBALS.DISPLAY_PLATFORM,
    ip: window.SP_GLOBALS.IP || "0.0.0.0",
    is_logged_in: await isLoggedIn(),
    language: window.SP_GLOBALS.SKYPICKER_LANGUAGE.phraseApp,
    locale: window.SP_GLOBALS.SKYPICKER_LANGUAGE.id,
    market: getCookie(Cookie.KW_MARKET) ?? undefined,
    referrer: document.referrer,
    session_id: getSession(sessionConsts.SESSION_ID) ?? "",
    user_agent: window.navigator.userAgent,
    utm: session.UTMs,
    visitor_id: getCookie(Cookie.USER_ID) ?? "",
    visitor_session_id: getCookie(Cookie.KW_SESSION_ID) ?? "",
  }
}
